export interface ScoreHistoryResponse {
  pre_assessment_id: string;
  latest_score: number;
  progress_from_last_assessment: number;
  is_positive: boolean;
  date: string;
  pre_assessment_history: PreAssessmentHistoryItem[];
  status: number;
  message: string;
  type: string;
  correlationId: string;
}

export interface PreAssessmentHistoryItem {
  date: string;
  value: number;
  progress_from_last_assessment: number;
  is_positive: boolean;
}

export enum TimePeriodFilter {
  Weekly = 1,
  Monthly = 2,
  Yearly = 3,
}

